import { render, staticRenderFns } from "./historyAssign.vue?vue&type=template&id=1e529b8c&scoped=true"
import script from "./historyAssign.vue?vue&type=script&lang=js"
export * from "./historyAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e529b8c",
  null
  
)

export default component.exports